import { combineReducers } from 'redux';
import type { FxSwapsState } from '../fxSwapsModel';
import { swapsReducer } from './fxSwapsProductReducer';
import { swapStreamsReducer } from './fxSwapsStreamsReducer';
export const fxSwapsReducer = combineReducers<FxSwapsState>({
  swaps: swapsReducer,
  streams: swapStreamsReducer,
});
